import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { INavigationLinkModel } from '@features/navigation/models/i-navigation-link.model';
import { RouterLink } from '@angular/router';
import { TooltipDirective } from '../../../../shared/directives/tooltip/tooltip.directive';
import { IconComponent } from '../../../../shared/components/icon/icon.component';

@Component({
  selector: 'navigation-item',
  templateUrl: './navigation-item.component.html',
  styleUrls: ['./navigation-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TooltipDirective, IconComponent],
})
export class NavigationItemComponent {
  @Input()
  public isLinkActive: boolean;
  @Input()
  public link: INavigationLinkModel;

  @Input()
  public isNavigationCollapsed: boolean;

  @Output()
  public navigationSelected: EventEmitter<INavigationLinkModel> = new EventEmitter();

  public onNavigationSelected(navItem: INavigationLinkModel) {
    this.navigationSelected.emit(navItem);
  }
}
